import { Inheritance, IntersectionOptionalFields } from 'src/domain';
import { MarkdownModel, MarkupModel, NoosShareExpectedModel } from 'src/infrastructure/rest-api/api-types';

export type ModuleExpectedNew = {
    id: number;
    monthKey: number;
    splitPct: number;
    styleCategoryId: number;
    modifiedByUser: boolean;
    splitPctLy: number;
    splitPctLly: number;
    grossMarginPctLy: number;
    cogsLy?: number;
    cogsLly?: number;
    netSalesLy?: number;
    grossSalesIly?: number;
    grossSalesIlly?: number;
};

type IntersectedModuleExpectedNew = IntersectionOptionalFields<MarkupModel, NoosShareExpectedModel, MarkdownModel>;

export const mapInheritanceToExpectedNew = (
    data: IntersectedModuleExpectedNew[] | undefined | null,
    inheritance: Inheritance //selectedInheritance
): ModuleExpectedNew[] | undefined => {
    return data?.reduce<ModuleExpectedNew[]>((acc, expected, index) => {
        if (!expected) return acc;
        switch (inheritance) {
            case Inheritance.Cluster:
            case Inheritance.Partner:
                acc.push({
                    id: expected?.id ?? index,
                    monthKey: expected.monthKey,
                    splitPct: expected.value ?? expected.splitPct ?? expected.markdownPct ?? 0,
                    styleCategoryId: expected.styleCategoryId,
                    modifiedByUser: expected?.modifiedByUser ?? false,
                    grossSalesIly: expected.grossSalesIly,
                    grossSalesIlly: expected.grossSalesIlly,
                    splitPctLy: expected.valueLy ?? expected.noosShareLy ?? expected.markdownPctLy ?? 0,
                    splitPctLly: expected.valueLly ?? expected.noosShareLly ?? 0,
                    grossMarginPctLy: expected.grossMarginDdrly ?? expected.grossMarginPctLy ?? 0,
                    cogsLly: expected.cogsLly,
                    cogsLy: expected.cogsLy,
                    netSalesLy: expected.netSalesLy,
                });

                break;

            case Inheritance.Typed:
                acc.push({
                    id: expected?.id ?? index,
                    monthKey: expected.monthKey,
                    splitPct: expected.splitPct ?? expected.value ?? expected.markdownPct ?? 0,
                    styleCategoryId: expected.styleCategoryId,
                    modifiedByUser: expected?.modifiedByUser ?? false,
                    grossSalesIly: expected.grossSalesIly,
                    grossSalesIlly: expected.grossSalesIlly,
                    splitPctLy: expected.valueLy ?? expected.noosShareDdrly ?? expected.markdownPctLy ?? 0,
                    splitPctLly: expected.valueLly ?? expected.noosShareDdrlly ?? 0,
                    grossMarginPctLy: expected.grossMarginDdrly ?? expected.grossMarginPctLy ?? 0,
                    cogsLly: expected.cogsLly,
                    cogsLy: expected.cogsLy,
                    netSalesLy: expected.netSalesLy,
                });

                break;

            case Inheritance.Historical:
                acc.push({
                    id: expected?.id ?? index,
                    monthKey: expected.monthKey,
                    splitPct: expected.valueLy ?? expected.noosShareLy ?? expected.markdownPctLy ?? 0,
                    styleCategoryId: expected.styleCategoryId,
                    modifiedByUser: false,
                    grossSalesIly: expected.grossSalesIly,
                    grossSalesIlly: expected.grossSalesIlly,
                    splitPctLy: expected.valueLy ?? expected.noosShareLy ?? expected.markdownPctLy ?? 0,
                    splitPctLly: expected.valueLly ?? expected.noosShareLly ?? 0,
                    grossMarginPctLy: expected.grossMarginSalesLy ?? expected.grossMarginPctLy ?? 0,
                    cogsLly: expected.cogsLly,
                    cogsLy: expected.cogsLy,
                    netSalesLy: expected.netSalesLy,
                });
                break;

            case Inheritance.NoosHistoricalOrders:
                acc.push({
                    id: expected?.id ?? index,
                    monthKey: expected.monthKey,
                    splitPct: expected.noosShareOrdersLy ?? 0,
                    styleCategoryId: expected.styleCategoryId,
                    modifiedByUser: false,
                    grossSalesIly: expected.grossMarginSalesLy ?? 0,
                    grossSalesIlly: undefined,
                    splitPctLy: expected.noosShareOrdersLy ?? 0,
                    splitPctLly: expected.noosShareOrdersLly ?? 0,
                    grossMarginPctLy: 0,
                });
                break;

            case Inheritance.NoosDDR:
                acc.push({
                    id: expected?.id ?? index,
                    monthKey: expected.monthKey,
                    splitPct: expected.noosShareDdrly ?? 0,
                    styleCategoryId: expected.styleCategoryId,
                    modifiedByUser: false,
                    splitPctLy: expected.noosShareDdrly ?? 0,
                    splitPctLly: expected.noosShareDdrlly ?? 0,
                    grossMarginPctLy: expected.grossMarginDdrly ?? 0,
                });
                break;
        }

        return acc;
    }, []);
};
